import React, { useState, useEffect, useCallback } from "react";
import { Checkbox, Select, Tooltip, Card, Icon, Col, Row, Button, DatePicker, Upload, message, Modal, Input, Tag } from "antd";
import {
    HazmatCheckboxIcon,
    PriorityIcon,
    SpecialIcon,
    IntermediateStorageIcon,
    IntermediateStorageCheckbox,
    SpecialCheckbox,
    PriorityCheckbox,
    PriorityCheckboxSelected,
    SpecialCheckboxSelected,
    IntermediateStorageCheckboxSelected,
    VehicleTypeIcon,
    PickupIcon,
    HazmatCheckbox,
    HazmatCheckboxSelected,
} from "../../common/CustomIcon";
import novehicle from "../../../assets/images/novehicle";
import { VehicleTypeApi } from "../../api/VehicleType";
import {
  updateOrderDetails_v2,
  saveImportDetails,
  editImportDetails,
  uploadCustomsClearanceFile,
  deleteOrderPic,
  cloneOrders,
  updateReadyForCustomerCall,
} from "../../api/OrdersApi";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import InfoTooltip from "./InfoTooltip";
import ColorTagSection from "../../components/orders/ColorTagSection";
import ReusableInput from "./ReusableInput";
import { isMultiDayOrder } from "../../helpers/order_managemnt";
import { formatFullName } from "../../helpers/common";
import { fetchHazmatClasses, fetchUNNumbers } from "../../api/HazmatApi";
import HazmatImg from "./HazmatImg";
import TruncatedText from "./TruncatedText";
import { validateApprovalError } from "../../helpers/approvalHelper";
import ApprovalRequiredModal from "../../components/configurations/orderApproval/ApprovalRequiredModal";
import UN_Number from "./orders/UN_Number";
import I18n from "../../common/I18n";
import MobileInput_v2 from "../../components/common/ReusableMobileInput";
import moment from "moment";
import ImportOrderModal from "./ImportOrderModal";
import UNNumberList from "../../common/UNNumberList";


const { Option } = Select;

const CUSTOMS_DOC_TYPES = [
  { code: "DELIVERY_ORDER", label: "delivery order" },
  { code: "CUSTOMS_RELEASE_DOCUMENT", label: "customs release document" },
  { code: "COPY_OF_CHECK_ACH_NUMBER", label: "copy of check" },
  { code: "CUSTOMS_STATUS_LOG", label: "customs status log (from descartes)" },
  { code: "MAWB_HAWB", label: "MAWB/HAWB" },
  { code: "CARGO_MANIFEST", label: "cargo manifest" }
];

const OptionsSectionView = ({
  currentOrder,
  currentOrg,
  onTagsUpdate,
  orgSettings,
  isLocked = false,
  orgRules,
  updateOptionsAndTags,
  refreshDetails,
  import_order_deliver_agent,
  autoOpenImportModal,
  onImportModalOpened,
  history,
  delivery_location_details,
}) => {
  const [selectedVehicleType, setSelectedVehicleType] = useState("");
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [open, setOpen] = useState(false);
  const [waitTime, setWaitTime] = useState(0);

  const details = currentOrder?.customer_order_details || {};
  const isOriginalBonded = !!details.is_inbound && !details.is_imported;
  const orderLabelCode = currentOrder?.label_code || details?.order_label || "";
  const [isCloningImportOrder, setIsCloningImportOrder] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [clonedImportData, setClonedImportData] = useState(null);


  const handleCreateImportOrderFromOptions = () => {
    setIsCloningImportOrder(true);
    cloneOrders({
      order_ids: [currentOrder.id],
      appointment_type: "EXISTING",
    })
      .then(result => {
        setIsCloningImportOrder(false);
        if (result.success) {
          const clonedOrder =
            result.orders?.[0] || result.order_details?.[0] || result.data?.order_details?.[0];
          if (clonedOrder) {
            setClonedImportData(clonedOrder);
            setShowImportModal(true);
          } else {
            message.error("Failed to retrieve cloned order details");
          }
        } else {
          message.error(result.errors?.join(", ") || "Failed to clone order");
        }
      })
      .catch(err => {
        setIsCloningImportOrder(false);
        console.error("Create Import Order error:", err);
        message.error("An error occurred while creating import order");
      });
  };

  // === IMPORT (INBOUND) & CUSTOMS CLEARANCE STATES ===
  const [inboundChecked, setInboundChecked] = useState(false);
  const [customClearanceChecked, setCustomClearanceChecked] = useState(false);
  const [isInboundSaved, setIsInboundSaved] = useState(false);
  const [bondedOrderChecked, setBondedOrderChecked] = useState(false);
  
  const [inboundName, setInboundName] = useState("");
  const [inboundPhone, setInboundPhone] = useState("");
  const [inboundAgentBrokerId, setInboundAgentBrokerId] = useState("");
  const [savedInboundName, setSavedInboundName] = useState("");
  const [savedInboundPhone, setSavedInboundPhone] = useState("");
  const [savedInboundAgentBrokerId, setSavedInboundAgentBrokerId] = useState("");
  const [freightArrivalDate, setFreightArrivalDate] = useState(null);
  const [savedFreightArrivalDate, setSavedFreightArrivalDate] = useState(null);
  const [lastFreeDay, setLastFreeDay] = useState("");
  const [savedLastFreeDay, setSavedLastFreeDay] = useState("");
  const [generalOrderDate, setGeneralOrderDate] = useState(null);
  const [savedGeneralOrderDate, setSavedGeneralOrderDate] = useState(null);
  const [inboundWasCheckedOnOpen, setInboundWasCheckedOnOpen] = useState(false);
  const [isInboundSaving, setIsInboundSaving] = useState(false);
  const [agentId, setAgentId] = useState("");

  const [customClearanceDate, setCustomClearanceDate] = useState(null);
  const [customClearancePhone, setCustomClearancePhone] = useState("");
  const [savedCustomClearanceDate, setSavedCustomClearanceDate] = useState(null);
  const [savedCustomClearancePhone, setSavedCustomClearancePhone] = useState("");
  const [savedCustomClearanceFilesMap, setSavedCustomClearanceFilesMap] = useState({});
  const [savedCustomClearanceFilesUploadedMap, setSavedCustomClearanceFilesUploadedMap] = useState({});
  const [existingCustomsDocsMap, setExistingCustomsDocsMap] = useState({}); // maps docTypeCode to persisted doc
  const [deletedClearanceDocIds, setDeletedClearanceDocIds] = useState([]);
  const [readyForCustomerChecked, setReadyForCustomerChecked] = useState(false);
  
  const [customClearanceFilesMap, setCustomClearanceFilesMap] = useState({});
  const [customClearanceFilesUploadedMap, setCustomClearanceFilesUploadedMap] = useState({});
  const [isUploadingCustomClearanceFileMap, setIsUploadingCustomClearanceFileMap] = useState({});
  const [customClearanceWasCheckedOnOpen, setCustomClearanceWasCheckedOnOpen] = useState(false);
  const [docPreviewVisible, setDocPreviewVisible] = useState(false);
  const [docPreviewUrl, setDocPreviewUrl] = useState(null);
  const [docPreviewType, setDocPreviewType] = useState(null); // 'image' | 'pdf'
  const [isUploadingAll, setIsUploadingAll] = useState(false);

  const [isInboundModalVisible, setIsInboundModalVisible] = useState(false);
  const [isCustomClearanceModalVisible, setIsCustomClearanceModalVisible] = useState(false);
  const [hasAutoOpened, setHasAutoOpened] = useState(false);

  const deliveryLocation = delivery_location_details || currentOrder?.delivery_location_details || {};
  const customerName = formatFullName(deliveryLocation, "customer_first_name", "customer_last_name") ||
                       formatFullName(deliveryLocation, "first_name", "last_name") ||
                       "";
  const companyName = deliveryLocation?.company_name || "";
  const customerLabel = !_.isEmpty(companyName) ? `Ready for customer - ${companyName}` :
                           !_.isEmpty(customerName) ? `Ready for customer - ${customerName}` : "Ready for customer";

  const handleReadyForCustomerChange = (checked) => {
    setReadyForCustomerChecked(checked);
    const orgId = currentOrg?.id || currentOrder?.customer_order_details?.organization_id || currentOrder?.organization_id;
    updateReadyForCustomerCall(currentOrder.id, checked, orgId)
      .then((result) => {
        if (result.success) {
          message.success("Successfully updated Ready for Customer status.");
          if (checked) {
            localStorage.setItem('ready_for_customer_' + currentOrder.id, 'true');
          } else {
            localStorage.removeItem('ready_for_customer_' + currentOrder.id);
          }
          if (refreshDetails) {
            refreshDetails();
          }
        } else {
          message.error("Failed to update Ready for Customer status.");
          setReadyForCustomerChecked(!checked);
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Failed to update Ready for Customer status.");
        setReadyForCustomerChecked(!checked);
      });
  };

  useEffect(() => {
    setHasAutoOpened(false);
  }, [currentOrder?.id]);

  const isPhoneEmpty = (phone) => {
    if (!phone) return true;
    const digits = phone.replace(/\D/g, "");
    return digits === "1" || digits === "91" || digits === "52" || digits === "";
  };

  const isInboundSaveDisabled =
    !inboundName?.trim() ||
    isPhoneEmpty(inboundPhone) ||
    !inboundAgentBrokerId?.trim() ||
    !freightArrivalDate ||
    !lastFreeDay ||
    !generalOrderDate ||
    isInboundSaving;

  const orderId = currentOrder?.id || currentOrder?.customer_order_details?.id || "";
  const allDocsUploaded = CUSTOMS_DOC_TYPES.every(type => {
    const existingDoc = existingCustomsDocsMap[type.code];
    const newFile = customClearanceFilesMap[type.code];
    const newFileUploaded = customClearanceFilesUploadedMap[type.code];
    return existingDoc || (newFile && (!orderId || newFileUploaded));
  });
  const anyUnuploadedDocs = orderId
    ? Object.keys(customClearanceFilesMap).some(code => {
        return customClearanceFilesMap[code] && !customClearanceFilesUploadedMap[code];
      })
    : false;
  const isCustomClearanceSaveDisabled =
    !customClearanceDate || anyUnuploadedDocs;

  const openInboundModal = useCallback(() => {
    setInboundName(savedInboundName);
    setInboundPhone(savedInboundPhone);
    setInboundAgentBrokerId(savedInboundAgentBrokerId);
    setFreightArrivalDate(savedFreightArrivalDate);
    setLastFreeDay(savedLastFreeDay);
    setGeneralOrderDate(savedGeneralOrderDate);
    setInboundWasCheckedOnOpen(inboundChecked);
    setIsInboundModalVisible(true);
  }, [
    savedInboundName,
    savedInboundPhone,
    savedInboundAgentBrokerId,
    savedFreightArrivalDate,
    savedLastFreeDay,
    savedGeneralOrderDate,
    inboundChecked,
  ]);

  useEffect(() => {
    if (!currentOrder?.id) return;
    if (hasAutoOpened) return;
    const details = currentOrder?.customer_order_details || {};
    const agent =
      import_order_deliver_agent ||
      currentOrder?.import_order_agent_details ||
      currentOrder?.customer_order_details?.import_order_agent_details ||
      currentOrder?.import_order_deliver_agent_details ||
      currentOrder?.customer_order_details?.import_order_deliver_agent_details;
    const hasAgent = !!(agent?.id || agent?._id || agent?.agent_id);
    const is_imported = !!details.is_imported;
    if ((autoOpenImportModal || is_imported) && !hasAgent) {
      setInboundChecked(true);
      openInboundModal();
      setHasAutoOpened(true);
      if (autoOpenImportModal) {
        onImportModalOpened();
      }
    }
  }, [
    autoOpenImportModal,
    currentOrder,
    import_order_deliver_agent,
    openInboundModal,
    hasAutoOpened,
  ]);

  const handleInboundCancel = () => {
    setIsInboundModalVisible(false);
    if (!inboundWasCheckedOnOpen && !agentId) {
      setInboundChecked(false);
    }
  };

  const handleInboundSave = async () => {
    setIsInboundSaving(true);
    try {
      const payload = {
        organization_id: currentOrg?.id || currentOrder?.customer_order_details?.organization_id,
        name: inboundName,
        phone_number: inboundPhone,
        agent_id: inboundAgentBrokerId,
        freight_arrival_date: freightArrivalDate,
        last_free_day: lastFreeDay,
        general_order_date: generalOrderDate,
        customer_order_id: currentOrder?.id,
      };
      if (agentId) {
        payload.id = agentId;
      }
      const response = await (agentId ? editImportDetails(payload) : saveImportDetails(payload));
      if (response && response.success) {
        if (!agentId) {
          setAgentId(
            response.agent?.id ||
              response.agent?._id ||
              response.agent?.agent_id ||
              inboundAgentBrokerId
          );
        }
        setSavedInboundName(inboundName);
        setSavedInboundPhone(inboundPhone);
        setSavedInboundAgentBrokerId(inboundAgentBrokerId);
        setSavedFreightArrivalDate(freightArrivalDate);
        setSavedLastFreeDay(lastFreeDay);
        setSavedGeneralOrderDate(generalOrderDate);
        setIsInboundSaved(true);
        setIsInboundModalVisible(false);
        message.success(response?.message || "Import Details saved successfully");
        handleSave();
      } else {
        const errorMsg = response?.errors?.join(", ") || "Failed to save Import Details";
        message.error(errorMsg);
      }
    } catch (error) {
      console.error("Error saving import details:", error);
      message.error("An error occurred while saving Import Details");
    } finally {
      setIsInboundSaving(false);
    }
  };

  const handleFileSelect = (file, docTypeCode) => {
    setCustomClearanceFilesMap((prev) => ({
      ...prev,
      [docTypeCode]: file,
    }));
    setCustomClearanceFilesUploadedMap((prev) => ({
      ...prev,
      [docTypeCode]: false,
    }));
  };

  const handleRemoveFile = (docTypeCode) => {
    setCustomClearanceFilesMap((prev) => {
      const copy = { ...prev };
      delete copy[docTypeCode];
      return copy;
    });
    setCustomClearanceFilesUploadedMap((prev) => {
      const copy = { ...prev };
      delete copy[docTypeCode];
      return copy;
    });
  };

  const handleRemoveExistingDoc = (docTypeCode, docId) => {
    setExistingCustomsDocsMap((prev) => {
      const copy = { ...prev };
      delete copy[docTypeCode];
      return copy;
    });
    if (docId) {
      setDeletedClearanceDocIds((prev) => [...prev, docId]);
    }
  };

  const openCustomClearanceModal = useCallback(() => {
    setCustomClearanceDate(savedCustomClearanceDate);
    setCustomClearancePhone(savedCustomClearancePhone);
    setCustomClearanceFilesMap(savedCustomClearanceFilesMap);
    setCustomClearanceFilesUploadedMap(savedCustomClearanceFilesUploadedMap);
    setCustomClearanceWasCheckedOnOpen(customClearanceChecked);
    setDeletedClearanceDocIds([]);

    const existingDocsMap = {};
    const locations = currentOrder?.locations;
    if (locations && locations.length > 0) {
      for (const loc of locations) {
        if (loc?.documents) {
          for (const doc of loc.documents) {
            const docCode = (doc?.pic_code || "").toUpperCase();
            const docTitle = (doc?.pic_title || "").toUpperCase();
            for (const type of CUSTOMS_DOC_TYPES) {
              if (docCode === type.code || docTitle === type.label.toUpperCase() || (type.code === "DELIVERY_ORDER" && docCode === "IMPORT")) {
                if (!existingDocsMap[type.code]) {
                  existingDocsMap[type.code] = doc;
                }
              }
            }
          }
        }
      }
    }
    setExistingCustomsDocsMap(existingDocsMap);
    setIsCustomClearanceModalVisible(true);
  }, [savedCustomClearanceDate, savedCustomClearancePhone, savedCustomClearanceFilesMap, savedCustomClearanceFilesUploadedMap, customClearanceChecked, currentOrder]);

  const handleCustomClearanceCancel = () => {
    setIsCustomClearanceModalVisible(false);
    if (!customClearanceWasCheckedOnOpen && !savedCustomClearanceDate) {
      setCustomClearanceChecked(false);
    }
  };

  const handleUploadCustomsFile = (file, docTypeCode, docTypeLabel) => {
    if (!file) return;
    setIsUploadingCustomClearanceFileMap((prev) => ({ ...prev, [docTypeCode]: true }));

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = reader.result;

      const orderId = currentOrder?.id || currentOrder?.customer_order_details?.id || "";
      const locationId = currentOrder?.locations?.[0]?.location_id || currentOrder?.locations?.[0]?.id || "";
      const ackId = Math.random().toString(36).substring(2, 15) + "_" + Date.now() + "_n";

      const payload = {
        refer: "order",
        order_ids: [orderId],
        location_id: locationId,
        pictures: [
          {
            refer_ids: [orderId],
            item_pictures: [
              {
                captured_at: new Date().toISOString(),
                picture_obj: file,
                ack_id: ackId,
                pic_title: docTypeLabel,
                pic_code: docTypeCode,
                image_type: "import",
                src: base64Data,
              }
            ]
          }
        ],
        pod_pic_settings: [
          {
            pic_code: docTypeCode,
            mandatory: true,
            mandatory_for: [
                "driver",
                "billing"
            ],
            required_for: "both"
          }
        ]
      };

      uploadCustomsClearanceFile(payload)
        .then((res) => {
          if (res && res.success) {
            setCustomClearanceFilesUploadedMap((prev) => ({ ...prev, [docTypeCode]: true }));
            message.success(`${docTypeLabel} uploaded successfully`);
          } else {
            message.error(res?.errors || `Failed to upload ${docTypeLabel}`);
          }
        })
        .catch((err) => {
          console.error("Upload error:", err);
          message.error("An error occurred during upload");
        })
        .finally(() => {
          setIsUploadingCustomClearanceFileMap((prev) => ({ ...prev, [docTypeCode]: false }));
        });
    };

    reader.onerror = (error) => {
      console.error("FileReader error:", error);
      message.error("Failed to read file");
      setIsUploadingCustomClearanceFileMap((prev) => ({ ...prev, [docTypeCode]: false }));
    };
  };

  const handleUploadAllCustomsFiles = () => {
    const filesToUpload = CUSTOMS_DOC_TYPES.filter(
      (type) => customClearanceFilesMap[type.code] && !customClearanceFilesUploadedMap[type.code]
    );

    if (filesToUpload.length === 0) return;

    setIsUploadingAll(true);

    const promises = filesToUpload.map((type) => {
      const file = customClearanceFilesMap[type.code];
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve({
            file,
            docTypeCode: type.code,
            docTypeLabel: type.label,
            base64Data: reader.result,
          });
        };
        reader.onerror = (error) => {
          reject(error);
        };
      });
    });

    Promise.all(promises)
      .then((fileDatas) => {
        const orderId = currentOrder?.id || currentOrder?.customer_order_details?.id || "";
        const locationId = currentOrder?.locations?.[0]?.location_id || currentOrder?.locations?.[0]?.id || "";

        const itemPictures = [];
        const podPicSettings = [];

        fileDatas.forEach(({ file, docTypeCode, docTypeLabel, base64Data }) => {
          const ackId = Math.random().toString(36).substring(2, 15) + "_" + Date.now() + "_n";
          itemPictures.push({
            captured_at: new Date().toISOString(),
            picture_obj: file,
            ack_id: ackId,
            pic_title: docTypeLabel,
            pic_code: docTypeCode,
            image_type: "import",
            src: base64Data,
          });

          podPicSettings.push({
            pic_code: docTypeCode,
            mandatory: true,
            mandatory_for: ["driver", "billing"],
            required_for: "both",
          });
        });

        const payload = {
          refer: "order",
          order_ids: [orderId],
          location_id: locationId,
          pictures: [
            {
              refer_ids: [orderId],
              item_pictures: itemPictures,
            },
          ],
          pod_pic_settings: podPicSettings,
        };

        return uploadCustomsClearanceFile(payload)
          .then((res) => {
            if (res && res.success) {
              setCustomClearanceFilesUploadedMap((prev) => {
                const next = { ...prev };
                filesToUpload.forEach((type) => {
                  next[type.code] = true;
                });
                return next;
              });
              message.success("All documents uploaded successfully");
            } else {
              message.error(res?.errors || "Failed to upload documents");
            }
          });
      })
      .catch((err) => {
        console.error("Upload all error:", err);
        message.error("An error occurred during upload");
      })
      .finally(() => {
        setIsUploadingAll(false);
      });
  };

  const handleCustomClearanceSave = () => {
    const orderId = currentOrder?.id || currentOrder?.customer_order_details?.id || "";
    if (orderId && deletedClearanceDocIds.length > 0) {
      const deletePromises = deletedClearanceDocIds.map((ackId) => {
        const data = {
          refer: "order",
          refer_id: orderId,
          ack_id: ackId,
          account_id: currentOrder?.account_id || currentOrder?.customer_order_details?.account_id,
          organization_id: currentOrg?.id || currentOrder?.organization_id,
        };
        return deleteOrderPic(data);
      });

      Promise.all(deletePromises)
        .then(() => {
          setDeletedClearanceDocIds([]);
        })
        .catch((err) => {
          console.error("Error deleting documents:", err);
        });
    }

    setSavedCustomClearanceDate(customClearanceDate);
    setSavedCustomClearancePhone(customClearancePhone);
    setSavedCustomClearanceFilesMap(customClearanceFilesMap);
    setSavedCustomClearanceFilesUploadedMap(customClearanceFilesUploadedMap);
    setIsCustomClearanceModalVisible(false);
    setCustomClearanceChecked(true);
    handleSave(customClearanceDate, customClearancePhone, true);
  };

  const handleInboundCheckboxChange = (checked) => {
    if (checked) {
      setInboundWasCheckedOnOpen(inboundChecked);
      openInboundModal();
      setInboundChecked(true);
    } else {
      if (customClearanceChecked) {
        Modal.confirm({
          title: "Are you sure you want to uncheck Import?",
          content: "Unchecking Import will also uncheck Customs Clearance.",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            setInboundChecked(false);
            setCustomClearanceChecked(false);
          },
          onCancel() {
            // Keep it checked
          }
        });
      } else {
        setInboundChecked(false);
      }
    }
  };

  const handleCustomClearanceCheckboxChange = (checked) => {
    if (!inboundChecked) return;
    if (checked) {
      setCustomClearanceWasCheckedOnOpen(customClearanceChecked);
      openCustomClearanceModal();
      setCustomClearanceChecked(true);
    } else {
      setCustomClearanceChecked(false);
    }
  };

  const [optionsArray, setOptionsArray] = useState([
    {
      label: "Intermediate Storage",
      checked: false,
      icon: <IntermediateStorageCheckbox />,
      payloadKey: "wh_storage",
      message: ["Signifies that the order will need to be stored temporarily in a warehouse before delivery and applies any configured rates."],
      checkedIcon: <IntermediateStorageCheckboxSelected />,
      tooltipIcon: <IntermediateStorageIcon />,
    },
    {
      label: "Linehaul Special",
      checked: false,
      icon: <SpecialCheckbox />,
      payloadKey: "linehaul_special",
      message: ["Applies the 'Special Day Adjustment' rate to this linehaul."],
      checkedIcon: <SpecialCheckboxSelected />,
      tooltipIcon: <SpecialIcon />,
    },
    {
      label: "Priority",
      checked: false,
      icon: <PriorityCheckbox />,
      payloadKey: "priority",
      message: ["Marks an order for priority delivery, ensuring it takes precedence along a route.  This is a standalone flag and not linked to rates."],
      checkedIcon: <PriorityCheckboxSelected />,
      tooltipIcon: <PriorityIcon />,
    },
  ]);
  const [hoveredField, setHoveredField] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [hazmatClasses, setHazmatClasses] = useState(null);

  // === HAZMAT STATE ===
  const [isHazardous, setIsHazardous] = useState(false);
  const [showUNModal, setShowUNModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubClass, setSelectedSubClass] = useState("");
  const [subClasses, setSubClasses] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [selectedUN, setSelectedUN] = useState("");
  const [UNNumbers, setUNNumbers] = useState(null);
  const [selectedUNNumber, setSelectedUNNumber] = useState([]);
  const [hazmatClass, setHazmatClass] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [pkgGroup, setPkgGroup] = useState("");
  const [emergencyResponseNumber, setEmergencyResponseNumber] = useState("");
  const [isPlacard, setIsPlacard] = useState(false);  
  const [description, setDescription] = useState("");
  const [editingUNIndex, setEditingUNIndex] = useState(null);

  const [approvalModal, setApprovalModal] = useState(false);
  const [isHazmat,setIsHazmat] = useState(false);
  const [restrictionMessage, setRestrictionMessage] = useState([]);
  const [reqLoading, setReqLoading] = useState(false);
  

  useEffect(() => {
    getVehicleTypes();
    getHazmatClasses();
    getUNnumbers();
  }, []);

  const getVehicleTypes = () => {
    VehicleTypeApi.fetch().then((result) => {
      if (result.success) {
        setVehicleTypes(result.vehicle_types || []);
      } else {
        renderNotification(result.errors, "error");
        setVehicleTypes(result.vehicle_types || []);
      }
    });
  };

  const getHazmatClasses = async () => {
    try {
      const result = await fetchHazmatClasses();
      if (result.success) {
        setHazmatClasses(result.hazmat_classes);
      }
    } catch (error) {
      console.error('Error fetching hazmat classes:', error);
      setHazmatClasses(null);
    }
  };

  const getUNnumbers = async () => {
    try {
      const result = await fetchUNNumbers({
        organization_id: currentOrg?.id || "",
      });
      if (result.success) {
        setUNNumbers(result.un_numbers);
      }
    } catch (error) {
      console.error('Error fetching UN numbers:', error);
      setUNNumbers(null);
    }
  };


  const getunNumberImage=()=>{
    const firstEntry = selectedUNNumber[0];
    const unNumber = typeof firstEntry === 'string' ? firstEntry : firstEntry?.un_number;
    const aa = UNNumbers?.filter(un => unNumber == un.un_number);
    return aa;
  }

  // === SYNC WITH currentOrder ===
  useEffect(() => {
    if (!currentOrder?.id) return;
    let isMounted = true;
    const { order_label, wh_storage, vehicle_type } = currentOrder?.customer_order_details || {};
    const hasPwlLocation = currentOrder?.locations?.some(o => o?.l_type === 'PWL');
    const lhOrder = currentOrder?.customer_order_details?.parent_lh_order?.lh_order_number ? true : false;
    const isMultiDay = isMultiDayOrder(currentOrder?.locations);
    const disabledCodes = ['LH', 'RD', 'RT', 'OBT', 'R', 'D', 'TR', 'TD', 'MS','NLH', 'PLHD','PLH','LHD'];
    const isWhStorageDisabled =
      isMultiDay || lhOrder ||
      disabledCodes.includes(order_label) ||
      (["OR", "OD"].includes(order_label) && hasPwlLocation);

    if (vehicle_type) {
      setSelectedVehicleType(vehicle_type);
    }
    const colotTag = _.get(currentOrder?.customer_order_details, "color_tags[0]", null) || null;
    const waitTime = _.get(currentOrder?.customer_order_details, "wait_time", null) || null;
    setSelectedColor(colotTag);
    setWaitTime(waitTime);

    const details = currentOrder?.customer_order_details || {};
    const hazmatChecked = !!details.is_hazardous;
    setIsHazardous(hazmatChecked);

    // Sync Hazmat class/subclass
    if (hazmatChecked) {
      if(orgRules?.org_billing_rules?.enable_UN_hazmat_fields === "true"){
      setSelectedUNNumber(normalizeUNNumbers(details.un_numbers));
      }else {
      if (details.hazmat_class && details.hazmat_division && details.hazmat_class !== "NA" && details.hazmat_division !== "NA") {
        const matchedClass = hazmatClasses?.find(c => c.class_name === details.hazmat_class);
        const matchedDiv = matchedClass?.sub_classes?.find(d => d.description === details.hazmat_division);
        setSelectedClass(matchedClass?.class_number || "");
        setSelectedSubClass(matchedDiv?.division || "");
      }}
    } else {
      setSelectedClass("");
      setSelectedSubClass("");
      setSubClasses([]);
      setSelectedUNNumber([]);
    }

    // Sync Import and Customs Clearance
    const isImported = !!details.is_imported;
    const isCustomsCleared = !!details.is_customs_cleared;
    setInboundChecked(isImported);
    setCustomClearanceChecked(isCustomsCleared);
    const orderId = currentOrder?.id || details?.id || details?._id;
    const isReady = !!details.ready_for_customer || (orderId && localStorage.getItem('ready_for_customer_' + orderId) === 'true');
    setReadyForCustomerChecked(!!isReady);
    setBondedOrderChecked(!!details.is_inbound);

    const agent = import_order_deliver_agent || 
                  currentOrder?.import_order_agent_details || 
                  currentOrder?.customer_order_details?.import_order_agent_details ||
                  currentOrder?.import_order_deliver_agent_details ||
                  currentOrder?.customer_order_details?.import_order_deliver_agent_details;

    if (isImported) {
      if (agent) {
        setAgentId(agent.id || agent._id || agent.agent_id || "");
        setSavedInboundName(agent.name || "");
        setInboundName(agent.name || "");
        setSavedInboundPhone(agent.phone_number || agent.phone || "");
        setInboundPhone(agent.phone_number || agent.phone || "");
        setSavedInboundAgentBrokerId(agent.agent_id || "");
        setInboundAgentBrokerId(agent.agent_id || "");
      }
      const arrivalDate = (agent && agent.freight_arrival_date) || details.freight_arrival_date || null;
      const freeDay = (agent && agent.last_free_day) || details.last_free_day || "";
      const generalDate = (agent && agent.general_order_date) || details.general_order_date || null;
      setSavedFreightArrivalDate(arrivalDate);
      setFreightArrivalDate(arrivalDate);
      setSavedLastFreeDay(freeDay);
      setLastFreeDay(freeDay);
      setSavedGeneralOrderDate(generalDate);
      setGeneralOrderDate(generalDate);
      setIsInboundSaved(true);
    } else {
      setAgentId("");
      setSavedInboundName("");
      setInboundName("");
      setSavedInboundPhone("");
      setInboundPhone("");
      setSavedInboundAgentBrokerId("");
      setInboundAgentBrokerId("");
      setSavedFreightArrivalDate(null);
      setFreightArrivalDate(null);
      setSavedLastFreeDay("");
      setLastFreeDay("");
      setSavedGeneralOrderDate(null);
      setGeneralOrderDate(null);
      setIsInboundSaved(false);
    }

    setSavedCustomClearanceDate(details.customs_cleared_date || null);
    setCustomClearanceDate(details.customs_cleared_date || null);
    setSavedCustomClearancePhone(details.customs_cleared_by || "");
    setCustomClearancePhone(details.customs_cleared_by || "");
    setSavedCustomClearanceFilesMap({});
    setCustomClearanceFilesMap({});
    setSavedCustomClearanceFilesUploadedMap({});
    setCustomClearanceFilesUploadedMap({});
    setDeletedClearanceDocIds([]);

    // Find existing customs documents
    const existingDocsMap = {};
    const locations = currentOrder?.locations;
    if (locations && locations.length > 0) {
      for (const loc of locations) {
        if (loc?.documents) {
          for (const doc of loc.documents) {
            const docCode = (doc?.pic_code || "").toUpperCase();
            const docTitle = (doc?.pic_title || "").toUpperCase();
            for (const type of CUSTOMS_DOC_TYPES) {
              if (docCode === type.code || docTitle === type.label.toUpperCase() || (type.code === "DELIVERY_ORDER" && docCode === "IMPORT")) {
                if (!existingDocsMap[type.code]) {
                  existingDocsMap[type.code] = doc;
                }
              }
            }
          }
        }
      }
    }
    setExistingCustomsDocsMap(existingDocsMap);

    setOptionsArray(
      optionsArray
        .filter((option) => {
          const codeToCheck = currentOrder?.label_code || order_label || "";
          
          if (option.payloadKey === "linehaul_special" && !['LH', 'NLH', 'PLH', 'LHD', 'PLHD'].includes(codeToCheck) && !details.is_lh_order) return false;
          return true;
        })
        .map((option) => {
          let checked = false;
          if (option.payloadKey === "wh_storage") {
            checked = wh_storage || (isMultiDay ? true : false);
          } else if (option.payloadKey === "linehaul_special") {
            checked = details.linehaul_special || false;
          } else {
            checked = details[option.payloadKey] || false;
          }
          return {
            ...option,
            checked,
            disabled: option.payloadKey === "wh_storage" ? isWhStorageDisabled : false,
          };
        })
    );

    return () => {
      isMounted = false;
    };
  }, [currentOrder, orgRules, hazmatClasses, currentOrg, import_order_deliver_agent]);

  useEffect(() => {
    if (!selectedClass) {
      setSubClasses([]);
      return;
    }
    const cls = hazmatClasses?.find(c => c.class_number === selectedClass);
    setSubClasses(cls?.sub_classes || []);
    isEditing && setSelectedSubClass("");
  }, [selectedClass]);

  const handleClassChange = (val) => {
    setSelectedClass(val);
    setIsEditing(true)
  }
  const handleSubClassChange = (val) => setSelectedSubClass(val);
  const handleUNNumberChange = (val) => {
    setSelectedUNNumber(val);
  };

  const handleUNLinkClick = (index) => {
    const entry = selectedUNNumber[index];
    const data = typeof entry === 'string' ? { un_number: entry } : entry;
    setSelectedUN(data?.un_number);
    setHazmatClass(data.hazmat_class || "");
    setPkgGroup(data.packing_group || "");
    setEmergencyResponseNumber(data.emergency_response_number || "");
    setIsPlacard(data.is_placard_required === true || data.is_placard_required === "true");
    setDescription(data.description || "");
    setEditingUNIndex(index);
    setShowUNModal(true);
  };

  const handleAddUNClick = () => {
    setSelectedUN("")
    setHazmatClass("");
    setPkgGroup("");
    setEmergencyResponseNumber("");
    setIsPlacard(false);
    setDescription("");
    setEditingUNIndex(null);
    setShowUNModal(true);
  };

  const handleUNNumberSave = (unNumberData) => {
    const updatedUNNumbers = selectedUNNumber?.slice() || [];
    if (editingUNIndex !== null) {
      updatedUNNumbers[editingUNIndex] = unNumberData;
    } else {
      updatedUNNumbers.push(unNumberData);
    }

    setSelectedUNNumber(updatedUNNumbers);
    setEditingUNIndex(null);
    setReqLoading(true)
    if(!isEditMode){
      handleSave(savedCustomClearanceDate, savedCustomClearancePhone, customClearanceChecked, updatedUNNumbers);
    }else{
      setShowUNModal(false)
    }
  };

  const removeUNNumber = (index) => {
    setSelectedUNNumber(prev => {
      const updated = prev.filter((_, i) => i !== index);

      if (updated.length === 0) {
        setIsHazardous(false);
      }

      return updated;
    });
  };

  const normalizeUNNumbers = (data) => {
    if (!data) return [];
    return data.map(entry =>
      typeof entry === 'string' ? { un_number: entry } : entry
    );
  };

  const handleApprovalValidation = (result) => {
      const {
        isHazmat,
        messages,
        requiresApproval,
      } = validateApprovalError(result.approval_errors);
    
      if (isHazmat) setIsHazmat(true);
    
      if (requiresApproval) {
        setApprovalModal(true);
        setRestrictionMessage(messages);
        
      }
    };

      const handleCloseApprovalModal = () => {
        setApprovalModal(false);
        setIsHazmat(false);
      }


  const handleSave = (customsDate = savedCustomClearanceDate, customsPhone = savedCustomClearancePhone, isCustomsCleared = customClearanceChecked, updatedUNNumbers = selectedUNNumber) => {
    const optionsMap = optionsArray.reduce((acc, item) => {
      acc[item.payloadKey] = item.checked;
      return acc;
    }, {});
    const unNumbers = updatedUNNumbers || selectedUNNumber;

    const selectedClassObj = hazmatClasses?.find(c => c.class_number === selectedClass);
    const selectedDivisionObj = subClasses.find(d => d.division === selectedSubClass);
    
    // setReqLoading(true);
    if (isHazardous) {

    if (orgRules?.org_billing_rules?.enable_UN_hazmat_fields !== "true") {
      if (!selectedClass) {
        renderNotification("Please select a Hazmat class.", "error");
        return;
      }
      if (!selectedSubClass) {
        renderNotification("Please select a Hazmat Division.", "error");
        return;
      }
    } else {
      if (selectedUNNumber.length === 0) {
        renderNotification("Please select a UN Number.", "error");
        return;
      }
    }
      // if (!selectedSubClass) {
      //   renderNotification("Please select a Hazmat Division.", "error");
      //   return;
      // }
    }

    const payload = {
      customer_order_params: {
        customer_order_id: currentOrder.id,
        warehouse_id: currentOrder?.customer_order_details?.warehouse_id || "",
        organization_id: currentOrg?.id || "",
      },
      options_block_params: {
        vehicle_type: selectedVehicleType,
        wh_storage: optionsMap?.wh_storage,
        pickup_special: optionsMap?.pickup_special,
        delivery_special: optionsMap?.delivery_special,
        linehaul_special: optionsMap?.linehaul_special,
        priority: optionsMap?.priority,
        is_hazardous: isHazardous,
        ...(orgRules?.org_billing_rules?.enable_UN_hazmat_fields !== "true" ? {
          hazmat_class: isHazardous ? selectedClassObj?.class_name || "" : "",
          hazmat_division: isHazardous ? selectedDivisionObj?.description || "" : "",
        } : 
        {un_numbers: unNumbers}
      ),
        color_tags: selectedColor ? [selectedColor] : [],
        wait_time: _.toNumber(waitTime),
        is_hazmat_request_approval: isHazmat.toString(),
        is_inbound: bondedOrderChecked,
        is_imported: inboundChecked,
        is_customs_cleared: isCustomsCleared,
        customs_cleared_by: customsPhone,
        customs_cleared_date: customsDate,
        freight_arrival_date: freightArrivalDate,
        last_free_day: lastFreeDay,
        general_order_date: generalOrderDate,
      },
    };


    updateOrderDetails_v2(currentOrder.id, payload).then((result) => {
      if (result.success) {
        renderNotification(
          `Order ${currentOrder.customer_order_details.customer_order_number} details have been updated`,
          "success"
        );
        const updatedTags = result?.response?.options_block?.tags || [];
        if (onTagsUpdate) {
          onTagsUpdate(updatedTags);
          updateOptionsAndTags({
            optionsAndTags: {
              vehicle_type: selectedVehicleType,
              wh_storage: optionsMap?.wh_storage,
              pickup_special: optionsMap?.pickup_special,
              delivery_special: optionsMap?.delivery_special,
              linehaul_special: optionsMap?.linehaul_special,
              priority: optionsMap?.priority,
              is_hazardous: isHazardous,
              hazmat_class: payload.options_block_params.hazmat_class,
              hazmat_division: payload.options_block_params.hazmat_division,
              un_numbers: selectedUNNumber,
              tags: updatedTags,
              color_tags: selectedColor ? [selectedColor] : [],
              wait_time: _.toNumber(waitTime),
              is_inbound: inboundChecked,
              is_imported: inboundChecked,
              is_customs_cleared: isCustomsCleared,
              customs_cleared_by: customsPhone,
              customs_cleared_date: customsDate,
            },
          });
        }
        setIsEditMode(false);
        setApprovalModal(false)
        refreshDetails();
        setReqLoading(false);
        setShowUNModal(false);
      } else {
        if(result.approval_errors && !isEmpty(result.approval_errors)){
             handleApprovalValidation(result);
            }else{
             renderNotification(result.errors, "error");
           }
      }
    });
  };

  const handleCheckboxChange = (index) => {
    setOptionsArray((prev) =>
      prev.map((option, i) => {
        if (i === index) {
          const nextChecked = !option.checked;
          if (option.payloadKey === "wh_storage" && !nextChecked) {
            setBondedOrderChecked(false);
          }
          return { ...option, checked: nextChecked };
        }
        return option;
      })
    );
  };

  const handleVehicleTypeChange = (value) => {
    setSelectedVehicleType(value);
  };

  const toggleEditMode = () => {
    setIsEditMode((prev) => !prev);
  };

  const handleDropdownChange = (openStatus) => {
    setOpen(openStatus);
  };

  const handleWaitTimeChange = (e) => {
    const value = Math.floor(e.target.value);
    if (value < 0) {
      setWaitTime(0);
      return;
    }
    setWaitTime(value);
  };

  useEffect(() => {
    if (isEditMode && isHazardous && !selectedClass && !selectedSubClass) {
      setSelectedClass(hazmatClasses?.[0]?.class_number || "");
      setSelectedSubClass(hazmatClasses?.[0]?.sub_classes?.[0]?.division || "");
    }
  }, [isEditMode, isHazardous])

  const unSource = UNNumbers || [];

  // Get the last occurrence index for each UN number
    const lastIndexMap = new Map();

    selectedUNNumber.forEach((val, index) => {
      const entry = typeof val === "string" ? { un_number: val } : val;
      if (entry?.un_number) {
        lastIndexMap.set(entry.un_number, index);
      }
    });

  return (
    <div className="OptionsContainer" style={{ marginBottom: "16px" }} data-testid="options-view">
      <Row style={{ display: "flex", justifyContent: "space-between" }}>
        <Col span={18}>
          <div className="heading-3-large">Options</div>
        </Col>
        <Col span={6}>
          {!isLocked && (
            <Button
              data-testid={`${isEditMode ? "save" : "edit"}`}
              type="link"
              className="button-2-large"
              style={{ background: "none", border: "none", cursor: "pointer" }}
              onClick={() => {
                if (isEditMode) {
                  handleSave();
                  return
                }
                toggleEditMode();
              }}
            >
              {isEditMode ? "Save" : "Edit"}
            </Button>
          )}
        </Col>
      </Row>

      <Row gutter={6} align="middle" style={!isEditMode && waitTime > _.toNumber(orgSettings?.wait_time_limit || 15) ? { backgroundColor: "#f7d0cc", padding: "2px", borderRadius: "10px" } : {}}>
        <Col className="select-dropdown-notes" span={isEditMode ? 24 : 18} style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onMouseEnter={() => setHoveredField('waitTime')}
            onMouseLeave={() => setHoveredField(null)}>
            <label>Wait Time</label>
            {hoveredField === 'waitTime' && (
              <InfoTooltip
                label="Wait Time"
                icon={<Icon type="clock-circle" theme="twoTone" />}
                message={[
                  "Enter the wait time in minutes. This is the time the driver will wait before starting the delivery.",
                ]}
              />
            )}
          </div>
          {isEditMode &&
            <ReusableInput
              value={waitTime}
              onChange={handleWaitTimeChange}
              placeholder="Enter Wait Time"
              type="number"
              size="middle"
              suffix="min"
            />
          }
        </Col>
        <Col span={6}>
          {!isEditMode &&
            (waitTime || 0) + " min"
          }
        </Col>
      </Row>

      {/* Vehicle Type Section */}
      <Row gutter={8} align="middle">
        <Col className="select-dropdown-notes" span={isEditMode ? 24 : 18} style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onMouseEnter={() => setHoveredField('vehicleType')}
            onMouseLeave={() => setHoveredField(null)}>
            <label>Vehicle Type</label>
            {hoveredField === 'vehicleType' && (
              <InfoTooltip
                label="Vehicle Type"
                icon={<VehicleTypeIcon />}
                message={["Select a vehicle type suitable for the order. Vehicle type affects delivery timing, costs, and other factors."]}
              />
            )}
          </div>
          {!isEditMode ? (
            <Tooltip title={selectedVehicleType || ""}>
              <div
                style={{
                  color: "#111314",
                  lineHeight: "24px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {selectedVehicleType || "Not Selected"}
              </div>
            </Tooltip>
          ) : (
            <Select
              data-testid="vehicle-type-dropdown"
              value={selectedVehicleType}
              onChange={handleVehicleTypeChange}
              suffixIcon={<Icon style={{ color: "#576ec1" }} type="caret-down" />}
              placeholder="Select Vehicle"
              className="OptionsStyle"
              style={{
                border: "1px solid #8897a4",
                borderRadius: "4px",
                color: "#8897a4",
                width: "100%",
              }}
              onDropdownVisibleChange={handleDropdownChange}
              dropdownAlign={{ offset: [0, -35] }}
            >
              {vehicleTypes.map((vehicle) => (
                <Option key={vehicle.code} value={vehicle.code}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img
                      src={vehicle.vehicle_image?.url || novehicle}
                      alt={vehicle.name}
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                    <span>{vehicle.name}</span>
                  </div>
                </Option>
              ))}
            </Select>
          )}
        </Col>
        <Col span={6}>
          {!isEditMode && selectedVehicleType && (() => {
            const selectedVehicle = vehicleTypes.find((v) => v.code === selectedVehicleType);
            return (
              <img
                src={selectedVehicle?.vehicle_image?.url || novehicle}
                alt={selectedVehicleType || "No Vehicle"}
                style={{
                  width: "48px",
                  height: "48px",
                  objectFit: "cover",
                  borderRadius: "4px",
                }}
              />
            );
          })()}
        </Col>
      </Row>

      {/* Dispatch Color */}
      {orgSettings?.require_dispatch_color === "true" && (
        <Row gutter={8} align="middle">
          <Col className="select-dropdown-notes" span={24} style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onMouseEnter={() => setHoveredField('dispatchColor')}
              onMouseLeave={() => setHoveredField(null)}>
              <label>Dispatch Color</label>
              {hoveredField === 'dispatchColor' && (
                <InfoTooltip
                  label="Dispatch Color"
                  icon={<PickupIcon />}
                  message={["Select a color for the order. This color is used to identify the order in the dispatch system and can be helpful for quick visual identification."]}
                />
              )}
            </div>
          </Col>
          <Col span={24}>
            <ColorTagSection isEditMode={isEditMode} selectedColor={selectedColor} setSelectedColor={setSelectedColor} />
          </Col>
        </Row>
      )}

      {/* Hazmat Section */}
      <div style={{ marginBottom: "8px" }}>
        <div
          className="select-dropdown-notes"
          style={{ marginBottom: "8px" }}
          onMouseEnter={() => setHoveredField('hazmat')}
          onMouseLeave={() => setHoveredField(null)}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label>
              {
                isEditMode ? (
                  <Checkbox
                    data-testid="hazmat-checkbox"
                    checked={isHazardous}
                    onChange={(e) => {
                      setIsHazardous(e.target.checked)
                      if (e.target.checked) {
                        handleAddUNClick();
                      } else {
                        setSelectedUNNumber([]);
                        setShowUNModal(false);
                        setEditingUNIndex(null);
                      }
                    }}
                  >
                    Hazmat
                  </Checkbox>
                ) : (
                  <>
                      {isHazardous && (
                        <>
                          {orgRules?.org_billing_rules?.enable_UN_hazmat_fields === "true" &&
                            getunNumberImage()?.[0]?.placard_logo ? (
                            <img
                              src={getunNumberImage()?.[0]?.placard_logo}
                              alt="Hazmat"
                              style={{ width: "24px", height: "24px" }}
                            />
                          ) : (
                              <HazmatImg hazmatClass={selectedClass} />
                          )}

                          <span style={{ marginLeft: "4px" }}>
                            <strong>Hazmat</strong>
                          </span>
                        </>
                      )}
                  </>
                )
              }
            </label>
            {hoveredField === 'hazmat' && (
              <InfoTooltip
                label="Hazmat"
                icon={<HazmatCheckboxIcon />}
                message={["Marks the order as containing hazardous materials (Hazmat) for dispatchers and drivers."]}
              />
            )}
          </div>

            <>
              {orgRules?.org_billing_rules?.enable_UN_hazmat_fields == "true" && isHazardous && (
              <>
                <UN_Number
                   visible={showUNModal}
                   onCancel={() => {
                       setShowUNModal(false);
                       setEditingUNIndex(null);
                       if(!selectedUNNumber.length) {
                           setIsHazardous(false);
                        }
                   }}
                   onSave={handleUNNumberSave}
                   unSource={unSource}
                   unNumber={editingUNIndex !== null ? selectedUNNumber[editingUNIndex] : null}
                   selectedUN={selectedUN}
                   setSelectedUN={setSelectedUN}
                   hazmatClass={hazmatClass}
                   emergencyResponseNumber={emergencyResponseNumber}
                   description={description}
                   setHazmatClass={setHazmatClass}
                   setEmergencyResponseNumber={setEmergencyResponseNumber}
                   setDescription={setDescription}
                   isEditing={editingUNIndex !== null}
                   pkgGroup={pkgGroup}
                   setPkgGroup={setPkgGroup}
                   isPlacard={isPlacard}
                   setIsPlacard={setIsPlacard}
                   isEditMode={isEditMode}
                   reqLoading={reqLoading}
                     />
              <UNNumberList
                  selectedUNNumber={selectedUNNumber}
                  lastIndexMap={lastIndexMap}
                  unSource={unSource}
                  handleUNLinkClick={handleUNLinkClick}
                  removeUNNumber={removeUNNumber}
                  handleAddUNClick={handleAddUNClick}
                  isEditMode={isEditMode}
                />
              </>
              )}
              {/* hazmat class and division */}
               {orgRules?.org_billing_rules?.enable_UN_hazmat_fields !== "true" && !isEditMode ? (
            <div style={{ color: "#111314", lineHeight: "24px" }}>
              {isHazardous && (
                <>
                  <strong>{hazmatClasses?.find(c => c.class_number === selectedClass)?.class_name}</strong>
                  {selectedSubClass && (
                    <> ({subClasses.find(s => s.division === selectedSubClass)?.description})</>
                  )}
                </>
              )}
            </div>
          ) : (
            <>
              {orgRules?.org_billing_rules?.enable_UN_hazmat_fields !== "true" && isHazardous && (
                <>
                  <label>Hazmat Class <span style={{ color: "red" }}>*</span></label>
                  <Select
                    allowClear
                    value={selectedClass}
                    onChange={handleClassChange}
                    placeholder="Select Hazmat Class"
                    className="OptionsStyle"
                    style={{
                      width: "100%",
                      border: "1px solid #8897a4",
                      borderRadius: "4px",
                      color: "#8897a4",
                      marginBottom: 8,
                    }}
                    suffixIcon={<Icon style={{ color: "#576ec1" }} type="caret-down" />}
                  >
                    {(hazmatClasses ?? []).map((cls) => (
                      <Option key={cls.class_number} value={cls.class_number}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <HazmatImg hazmatClass={cls.class_number} />
                          <TruncatedText text={cls.class_name} />
                        </div>
                      </Option>
                    ))}
                  </Select>

                  {selectedClass && (
                    <div>
                      <label>Hazmat Division <span style={{ color: "red" }}>*</span></label>
                      <Select
                        value={selectedSubClass}
                        onChange={handleSubClassChange}
                        placeholder="Select Sub-Class (Required)"
                        status={!selectedSubClass ? "error" : ""}
                        className="OptionsStyle"
                        style={{
                          width: "100%",
                          border: "1px solid #8897a4",
                          borderRadius: "4px",
                          color: "#8897a4",
                        }}
                        suffixIcon={<Icon style={{ color: "#576ec1" }} type="caret-down" />}
                      >
                        {subClasses.map((sub) => (
                          <Option key={sub.division} value={sub.division}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              <HazmatImg hazmatClass={sub.division} />
                              <TruncatedText text={sub.description} />
                            </div>
                          </Option>
                        ))}
                      </Select>
                      {!selectedSubClass && (
                        <div style={{ fontSize: "12px", color: "#ff4d4f", marginTop: "4px" }}>
                          Sub-class selection is required when Hazmat class is selected.
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
            </>
        </div>
      </div>

      {/* Other Checkboxes */}
      <div className="checkbox-container">
        {optionsArray
          .filter((option) => isEditMode || option.checked)
          .map((option, index) => {
            const actualIndex = optionsArray.indexOf(option);
            return (
              <React.Fragment key={actualIndex}>
                <div
                  className="OptionsStyleCheckbox"
                  style={{
                    cursor: isEditMode || option.checked ? "pointer" : "default",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={() => setHoveredField(option.payloadKey)}
                  onMouseLeave={() => setHoveredField(null)}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {isEditMode ? (
                      <Checkbox
                        data-testid={`${option.label}-checkbox`}
                        checked={option.checked}
                        onChange={() => handleCheckboxChange(actualIndex)}
                        disabled={option.disabled || false}
                      >
                        {option.label}
                      </Checkbox>
                    ) : (
                      <>
                        {option.checkedIcon} &nbsp;
                        <span>
                          <strong>{option.label}</strong>
                        </span>
                      </>
                    )}
                    {hoveredField === option.payloadKey && (
                      <div style={{ marginLeft: "8px" }}>
                        <InfoTooltip
                          label={option.label}
                          icon={option.tooltipIcon}
                          message={[option.message]}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Bonded Order checkbox/status under Intermediate Storage */}
                {option.payloadKey === "wh_storage" && orderLabelCode === "PLH" && (
                  <div
                    className="OptionsStyleCheckbox"
                    style={{
                      cursor: isEditMode && option.checked && !details?.inbound_order_numbers?.import_order_number ? "pointer" : "default",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "4px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {isEditMode ? (
                        <Checkbox
                          data-testid="bonded-order-checkbox"
                          className="OptionsStyle"
                          checked={bondedOrderChecked}
                          disabled={!option.checked || !!details?.inbound_order_numbers?.import_order_number}
                          onChange={(e) => {
                            if (!details?.inbound_order_numbers?.import_order_number) {
                              setBondedOrderChecked(e.target.checked);
                            }
                          }}
                        >
                          Bonded Order
                        </Checkbox>
                      ) : (
                        bondedOrderChecked && (
                          <>
                            <Icon type="check-circle" theme="filled" style={{ color: "#52c41a", fontSize: "16px" }} /> &nbsp;
                            <span>
                              <strong>Bonded Order</strong>
                            </span>
                          </>
                        )
                      )}
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}

        {/* Import & Customs Clearance rendered independently */}
        {currentOrder?.id && (
          <>


            {!!details.is_imported && !isOriginalBonded && (isEditMode || inboundChecked) && (
              <div
                className="OptionsStyleCheckbox"
                style={{
                  cursor: isEditMode || inboundChecked ? "pointer" : "default",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isEditMode ? (
                    <>
                      <Checkbox
                        data-testid="inbound-checkbox"
                        className="OptionsStyle"
                        checked={inboundChecked}
                        disabled={!!agentId}
                        onChange={(e) => {
                          if (!agentId) {
                            handleInboundCheckboxChange(e.target.checked);
                          }
                        }}
                      >
                        Import
                      </Checkbox>
                      {inboundChecked && (
                        <Icon
                          type="edit"
                          style={{ marginLeft: "8px", cursor: "pointer", color: "#576ec1" }}
                          onClick={openInboundModal}
                          data-testid="edit-inbound-icon"
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <Icon type="check-circle" theme="filled" style={{ color: "#52c41a", fontSize: "16px" }} /> &nbsp;
                      <span>
                        <strong>Imported Order</strong>
                      </span>
                    </>
                  )}
                </div>
              </div>
            )}

            {!!details.is_imported && !isOriginalBonded && (isEditMode || customClearanceChecked) && (
              <div
                className="OptionsStyleCheckbox"
                style={{
                  cursor: isEditMode || customClearanceChecked ? "pointer" : "default",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {isEditMode ? (
                    <>
                      <Checkbox
                        data-testid="custom-clearance-checkbox"
                        className="OptionsStyle"
                        checked={customClearanceChecked}
                        disabled={!inboundChecked || !!savedCustomClearanceDate}
                        onChange={e => {
                          if (!savedCustomClearanceDate) {
                            handleCustomClearanceCheckboxChange(e.target.checked);
                          }
                        }}
                      >
                        Customs Clearance
                      </Checkbox>
                      {inboundChecked && customClearanceChecked && (
                        <Icon
                          type="edit"
                          style={{ marginLeft: "8px", cursor: "pointer", color: "#576ec1" }}
                          onClick={openCustomClearanceModal}
                          data-testid="edit-custom-clearance-icon"
                        />
                      )}
                    </>
                  ) : allDocsUploaded ? (
                    <>
                      <Icon
                        type="check-circle"
                        theme="filled"
                        style={{ color: "#52c41a", fontSize: "16px" }}
                      />{" "}
                      &nbsp;
                      <span>
                        <strong>Customs Cleared</strong>
                      </span>
                    </>
                  ) : null}
                </div>
              </div>
            )}

            {inboundChecked && customClearanceChecked && (isEditMode || readyForCustomerChecked) && (
              <div
                className="OptionsStyleCheckbox"
                style={{
                  cursor: (isLocked || details.status === "COMPLETED" || !allDocsUploaded) ? "default" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {
                    isEditMode && !currentOrder?.ready_for_customer ? (
                      <Checkbox
                    data-testid="ready-for-customer-checkbox"
                    className="OptionsStyle"
                    checked={readyForCustomerChecked}
                    disabled={isLocked || details.status === "COMPLETED" || !allDocsUploaded}
                    onChange={e => handleReadyForCustomerChange(e.target.checked)}
                  >
                    {customerLabel}
                  </Checkbox>
                    ) : (
                      <>
                        <Icon
                          type="check-circle"
                          theme="filled"
                          style={{ color: "#52c41a", fontSize: "16px" }}
                        />{" "}
                        &nbsp;
                        <span>
                          <strong>{customerLabel}</strong>
                        </span>
                      </>
                    )
                  }
                  
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <ApprovalRequiredModal 
          visible={approvalModal} 
          onCancel={() => handleCloseApprovalModal(false)} 
          onRequestApproval={handleSave} 
          restrictionMessage={restrictionMessage} 
          reqLoading={false}
          />

      {/* Inbound Modal */}
      <Modal
        title="Agent/Broker Details"
        visible={isInboundModalVisible}
        onOk={handleInboundSave}
        onCancel={handleInboundCancel}
        footer={[
          <Button
            data-testid="cancel-inbound-button"
            key="cancel"
            className="medium-btn flat"
            type="link"
            onClick={handleInboundCancel}
          >
            Cancel
          </Button>,
          <Button
            data-testid="save-inbound-button"
            key="save"
            className="medium-btn flat"
            type="link"
            onClick={handleInboundSave}
            disabled={isInboundSaveDisabled}
            loading={isInboundSaving}
          >
            Save
          </Button>,
        ]}
        centered
        width={360}
        closable={false}
        style={{ top: 20 }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
              Name
              <sup style={{ color: "red" }}>*</sup>
            </div>
            <Input
              data-testid="inbound-name-input"
              value={inboundName}
              onChange={(e) => setInboundName(e.target.value)}
              placeholder="Enter name"
            />
          </div>

          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
              Phone No
              <sup style={{ color: "red" }}>*</sup>
            </div>
            <MobileInput_v2
              value={inboundPhone}
              handleInputChange={(val) => setInboundPhone(val)}
            />
          </div>

          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
              Agent/Broker ID
              <sup style={{ color: "red" }}>*</sup> 
            </div>
            <Input
              data-testid="inbound-agent-broker-id-input"
              value={inboundAgentBrokerId}
              onChange={(e) => setInboundAgentBrokerId(e.target.value)}
              placeholder="Enter Agent/Broker ID"
            />
          </div>
          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
              Freight Arrival Date
            <sup style={{ color: "red" }}>*</sup>
            </div>
            <DatePicker
              data-testid="inbound-freight-arrival-date-picker"
              value={freightArrivalDate ? moment(freightArrivalDate) : null}
              onChange={date => setFreightArrivalDate(date ? date.toISOString() : null)}
              style={{ width: "100%" }}
            />
          </div>

          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
              Last Free Day of Storage
            <sup style={{ color: "red" }}>*</sup>
            </div>
            <DatePicker
              data-testid="inbound-last-free-day-picker"
              value={lastFreeDay ? moment(lastFreeDay) : null}
              onChange={date => setLastFreeDay(date ? date.toISOString() : null)}
              style={{ width: "100%" }}
            />
          </div>

          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "4px" }}>
              General Order Date
              <sup style={{ color: "red" }}>*</sup>
            </div>
            <DatePicker
              data-testid="inbound-general-order-date-picker"
              value={generalOrderDate ? moment(generalOrderDate) : null}
              onChange={date => setGeneralOrderDate(date ? date.toISOString() : null)}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </Modal>

      {/* Custom Clearance Modal */}
      <Modal
        title="Customs Clearance Details"
        visible={isCustomClearanceModalVisible}
        onOk={handleCustomClearanceSave}
        onCancel={handleCustomClearanceCancel}
        footer={[
          <Button
            data-testid="cancel-custom-clearance-button"
            key="cancel"
            className="medium-btn flat"
            type="link"
            onClick={handleCustomClearanceCancel}
          >
            Cancel
          </Button>,
          <Button
            data-testid="save-custom-clearance-button"
            key="save"
            className="medium-btn flat"
            type="link"
            onClick={handleCustomClearanceSave}
            disabled={isCustomClearanceSaveDisabled}
          >
            {allDocsUploaded ? "Customs Cleared" : "Save"}
          </Button>,
        ]}
        centered
        width={550}
        closable={false}
        style={{ top: 20 }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <div className="caption-large-emphasis" style={{ marginBottom: "6px" }}>
              Clearance Date
              <sup style={{ color: "red" }}>*</sup>
            </div>
            <DatePicker
              data-testid="clearance-date-picker"
              value={customClearanceDate ? moment(customClearanceDate) : null}
              onChange={(date, dateString) => setCustomClearanceDate(dateString)}
              style={{ width: "100%" }}
              placeholder="Select Date"
            />
          </div>

          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <span className="caption-large-emphasis">Required Customs Documents</span>
              {currentOrder?.id && CUSTOMS_DOC_TYPES.some(type => customClearanceFilesMap[type.code] && !customClearanceFilesUploadedMap[type.code]) && (
                <Button
                  data-testid="upload-all-customs-docs-btn"
                  className="medium-btn flat"
                  type="link"
                  onClick={handleUploadAllCustomsFiles}
                  loading={isUploadingAll}
                  style={{ display: "flex", alignItems: "center", gap: "4px", height: "28px", fontSize: "12px", padding: "0 8px" }}
                >
                  {!isUploadingAll && <Icon type="upload" />}
                  <span>Upload</span>
                </Button>
              )}
            </div>
            <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "4px" }}>
              {CUSTOMS_DOC_TYPES.map((type) => {
                const existingDoc = existingCustomsDocsMap[type.code];
                const file = customClearanceFilesMap[type.code];
                const isUploaded = customClearanceFilesUploadedMap[type.code];
                const isUploading = isUploadingCustomClearanceFileMap[type.code];
                const orderId = currentOrder?.id || currentOrder?.customer_order_details?.id || "";

                return (
                  <div
                    key={type.code}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      background: "#fafafa",
                      border: "1px solid #f0f0f0",
                      borderRadius: "6px",
                      marginBottom: "8px"
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px", maxWidth: "55%" }}>
                      <span className="caption-large-emphasis" style={{ textTransform: "capitalize", color: "#111314", fontSize: "12px" }}>
                        {type.label}
                      </span>
                    </div>
                    <div>
                      {existingDoc ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", background: "#f6ffed", border: "1px solid #b7eb8f", padding: "4px 8px", borderRadius: "4px" }}>
                          <span
                            style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "11px", color: "#389e0d", textDecoration: "underline", cursor: "pointer" }}
                            onClick={() => {
                              const url = existingDoc.picture_url;
                              const isPdf = url?.toLowerCase().endsWith(".pdf");
                              setDocPreviewUrl(url);
                              setDocPreviewType(isPdf ? "pdf" : "image");
                              setDocPreviewVisible(true);
                            }}
                          >
                            <Icon type={existingDoc.picture_url?.toLowerCase().endsWith(".pdf") ? "file-pdf" : "file-image"} style={{ marginRight: "4px", color: "#52c41a" }} />
                            {existingDoc.picture_url.split("/").pop() || "Document"}
                          </span>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Icon type="check-circle" theme="filled" style={{ color: "#52c41a", fontSize: "13px" }} />
                            <Tooltip title="Remove">
                              <Icon
                                type="delete"
                                style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "13px" }}
                                onClick={() => handleRemoveExistingDoc(type.code, existingDoc.ack_id)}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      ) : file ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", background: "#e6f7ff", border: "1px solid #91d5ff", padding: "4px 8px", borderRadius: "4px" }}>
                          <span style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "11px", color: "#0050b3" }}>
                            <Icon type="paper-clip" style={{ marginRight: "4px" }} />
                            {file.name}
                          </span>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Tooltip title="Preview">
                              <Icon
                                type="eye"
                                style={{ color: "#1890ff", cursor: "pointer", fontSize: "13px" }}
                                onClick={() => {
                                  const objectUrl = URL.createObjectURL(file);
                                  const isPdf = file?.type === "application/pdf" || file?.name?.toLowerCase().endsWith(".pdf");
                                  setDocPreviewUrl(objectUrl);
                                  setDocPreviewType(isPdf ? "pdf" : "image");
                                  setDocPreviewVisible(true);
                                }}
                              />
                            </Tooltip>
                            {(isUploaded || !orderId) && (
                              <Icon type="check-circle" theme="filled" style={{ color: "#52c41a", fontSize: "13px" }} />
                            )}
                            <Tooltip title="Remove">
                              <Icon
                                type="delete"
                                style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "13px" }}
                                onClick={() => handleRemoveFile(type.code)}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      ) : (
                        <Upload
                          beforeUpload={(f) => {
                            handleFileSelect(f, type.code);
                            return false;
                          }}
                          showUploadList={false}
                        >
                          <Button style={{ display: "flex", alignItems: "center", gap: "4px", borderRadius: "4px", height: "28px", fontSize: "11px", border: "1px dashed #d9d9d9", color: "#576ec1", background: "#f9fbfd" }}>
                            <Icon type="upload" /> Select File
                          </Button>
                        </Upload>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Modal>

      {/* Doc Preview Modal */}
      <Modal
        visible={docPreviewVisible}
        footer={null}
        onCancel={() => setDocPreviewVisible(false)}
        centered
        width={docPreviewType === "pdf" ? 800 : "auto"}
        bodyStyle={{ padding: 0, textAlign: "center" }}
        title={
          <span style={{ fontSize: "13px", color: "#576ec1" }}>
            {docPreviewUrl?.split("/").pop() || "Document Preview"}
          </span>
        }
      >
        {docPreviewType === "image" ? (
          <img src={docPreviewUrl} alt="Clearance Document" style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }} />
        ) : docPreviewType === "pdf" ? (
          <iframe src={docPreviewUrl} title="Clearance PDF" style={{ width: "100%", height: "80vh", border: "none" }} />
        ) : null}
      </Modal>
      <ImportOrderModal
        visible={showImportModal}
        onCancel={() => setShowImportModal(false)}
        data={clonedImportData}
        history={history}
      />
    </div>
  );
};

export default OptionsSectionView;
